const CACHE_NAME = "auth"
const TOKEN_KEY = "token"

// Cache Storage was designed for caching
// network requests with service workers,
// mainly to make PWAs work offline.
// You can give it any value you want in this case.
const FAKE_ENDPOINT = "/firstline-token"

export const saveToken = async token => {
  try {
    const cache = await caches.open(CACHE_NAME)
    const responseBody = JSON.stringify({
      [TOKEN_KEY]: token
    })
    const response = new Response(responseBody)
    await cache.put(FAKE_ENDPOINT, response)
    console.log("Token saved! 🎉")
  } catch (error) {
    // It's up to you how you resolve the error
    console.log("saveToken error:", { error })
  }
}

export const getToken = async () => {
  try {
    const cache = await caches.open(CACHE_NAME)
    const response = await cache.match(FAKE_ENDPOINT)

    if (!response) {
      return null
    }

    const responseBody = await response.json()
    console.log("responseBody", responseBody)
    return responseBody[TOKEN_KEY]
  } catch (error) {
    // Gotta catch 'em all
    return ""
  }
}

export const clearToken = async () => {
  try {
    return await caches.delete(CACHE_NAME)
  } catch (error) {
    // Gotta catch 'em all
    return ""
  }
}



// WEBPACK FOOTER //
// ./src/utils/cacheToken.js